import React = require("react");
import {BarChartRow} from "../charts/BarChart";
import {BarChart} from "../charts/BarChart2yAxis";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Display} from "../../../components/Display";
import {EmptyState, infoIcons} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;

export interface BarChart2ValuesRow extends BarChartRow {
    value2: number;
}

interface LargeHistogramChartWidget2AxisProps {
    title: string;
    data: BarChart2ValuesRow[];
    yUnitOfMeasure: string;
    y1UnitOfMeasure: string;
}


export class LargeHistogramChartWidget2Axis extends React.Component<LargeHistogramChartWidget2AxisProps, {}> {

    constructor(props: LargeHistogramChartWidget2AxisProps) {
        super(props);
    }

    public render() {
        return (
            <VeBoxCard className="marketing-widget marketing-widget-large no-margin">
                <AutoSizer disableHeight style={{width: "100%", height: "100%"}}>
                    {({width}) =>
                        <><VeBoxCard.Header title={this.props.title}/>
                            <VeBoxCard.Body className="marketing-widget__content">
                                <Display isVisible={this.props.data.length === 0}>
                                    <EmptyState>
                                        <EmptyState.InfoIcon
                                            styles={{
                                                root: {
                                                    color: "var(--empty-indicator-svg-stroke)",
                                                }
                                            }}
                                            glyph={infoIcons.NoContent}
                                        />
                                        <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                                        <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                                    </EmptyState>
                                </Display>
                                <Display isVisible={this.props.data.length > 0}>
                                    <BarChart
                                        width={width - 50}
                                        height={430}
                                        color={null}
                                        data={this.props.data}
                                        yUnitOfMeasure={this.props.yUnitOfMeasure}
                                        y1UnitOfMeasure={this.props.y1UnitOfMeasure}
                                    />
                                </Display>
                            </VeBoxCard.Body>
                        </>}</AutoSizer>
            </VeBoxCard>
        );
    }
}
